import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { AuraDropdownComponent } from './aura-dropdown/aura-dropdown.component';
import { ScrollShowHideDirective } from './scrollShowHide/scroll-show-hide.directive';
import { SocialsBarComponent } from './socialsBar/socials-bar/socials-bar.component';
import { CustomIconComponent } from './custom-icon/custom-icon.component';
import { PricingModalComponent } from './pricing-modal/pricing-modal.component';
import { PricingContactComponent } from './pricing-modal/pricing-contact/pricing-contact.component';
import { PricingSwitcherComponent } from './pricing-switcher/pricing-switcher.component';
import { ParallaxStarsComponent } from './parallax-stars/parallax-stars.component';
import {NgxStripeModule} from "ngx-stripe";

const modules = [
	CommonModule,
	FormsModule,
	ReactiveFormsModule,

	// Angular Material
	MatBottomSheetModule,
	MatButtonModule,
	MatChipsModule,
	MatFormFieldModule,
	MatIconModule,
	MatInputModule,
	MatListModule,
	MatMenuModule,
	MatProgressSpinnerModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatTooltipModule,
	MatMomentDateModule,
	MatSelectModule,
	MatDialogModule,
	MatExpansionModule,
	MatTabsModule,
	MatCheckboxModule,
	MatRadioModule,
	MatSidenavModule,
	MatStepperModule,
	MatProgressBarModule,
	MatButtonToggleModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatAutocompleteModule,
];

const components = [
	AuraDropdownComponent,
	CustomIconComponent,
	PricingModalComponent,
	PricingContactComponent,
	PricingSwitcherComponent,
	ParallaxStarsComponent,
	SocialsBarComponent,
];

@NgModule({
  imports: [...modules, NgxStripeModule],
	declarations: [...components, ScrollShowHideDirective],
	exports: [...modules, ...components, ScrollShowHideDirective],
})
export class SharedModule {}
